import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAlerts from 'customHook/useAlerts';
import { AlertBoxContainer, AlertItem } from './styles';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import { RemoveIcon } from 'assets/icons';
import colors from 'constants/colors'

const AlertBox = ({ active }) => {

  const navigate = useNavigate();
  const { data, updateAlertStatus } = useAlerts();

  const colorMap = {
    'STAYOVER': colors.orange,
    'INFO': colors.purple,
    'GUEST_CHECKED_IN': colors.lightGreen,
    'GUEST_CHECKED_OUT': colors.darkGrey,
    'GUEST_CANCELLED': colors.red,
    'BOOKING_CREATED': colors.blue,
    'default': colors.darkGrey
  }

  const alertArray = data?.allRoomAlerts?.slice(0, 2)?.map(boxedAlert => {
    return (
      <AlertItem
        key={boxedAlert.alertId}
        color={colorMap[boxedAlert.type]?? colorMap['default']}
      >
        <div
          className='alertBody'
          onClick={(event) => {
            if(!boxedAlert.isRead) {
              updateAlertStatus({
                variables: {
                  alertId: boxedAlert.alertId,
                }
              }).then(() => {
                //TODO: maybe add some indication that alert is read
              })
            }
            if (event.metaKey || event.ctrlKey) {
              // Open new tab with absolute URL
              if(boxedAlert.roomBooking?.booking?.group?.groupId) {
                window.open(`https://pms.rookhotel.com/booking-details/${boxedAlert.roomBooking?.booking?.group?.groupId}`, '_blank', 'noopener,noreferrer');
              }
            } else {
              if(boxedAlert.roomBooking?.booking?.group?.groupId) {
                navigate(`/booking-details/${boxedAlert.roomBooking?.booking?.group?.groupId}`)
              }
            }
          }}
        >
          <div className='alertTitle'>
            <span className='alertType'>{boxedAlert.type?.replaceAll('_', ' ')}</span>
            {boxedAlert.room?.roomNumber && <span className='roomNumber'>{'Room ' + boxedAlert.room?.roomNumber}</span>}
          </div>
          <div className='content'>
            <div className='alertInfo'>
              <span className='originator'>{boxedAlert.originator}</span>
              <span className='dateTime'>{moment(boxedAlert.createdAt).tz(TIME_ZONE).format('MMM Do YYYY h:mm A')}</span> 
            </div>
            <div className='description'>{boxedAlert.description}</div>
          </div>
        </div>
        <div
          className='link'
          onClick={(event) => {
            if(!boxedAlert.isRead) {
              updateAlertStatus({
                variables: {
                  alertId: boxedAlert.alertId,
                }
              }).then(() => {
                //TODO: maybe add some indication that alert is read
              })
            }
          }}
        >
          <RemoveIcon />
        </div>
      </AlertItem>
    )
  }) || [];

  return (
    <AlertBoxContainer active={active}>
      {alertArray}
    </AlertBoxContainer>
  )
}

export default AlertBox;